import '../plugins/BlockCoverPlugin.js';

export default function initBlockCover() {
	jQuery('.bg-stretch iframe').blockCover();
}
